import { Injectable } from '@angular/core';
import { Estacao } from '../../../models';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { ESTACAO_CL } from '../../../shared';

@Injectable()

export class EstacoesService {
    private ref: AngularFirestoreCollection<Estacao>;

    constructor(private afs: AngularFirestore) {
        this.ref = this.afs.collection<Estacao>(ESTACAO_CL, ref => ref.orderBy('nome').limit(1000));
    }

    listar() {
        return this.ref.snapshotChanges()
            .pipe(
                map(actions =>
                    actions.map(a => {
                        const data = a.payload.doc.data();
                        const id = a.payload.doc.id;
                        return { id, ...data };
                    }))
            );
    }

    filtrar(busca: string, tipo: string) {
        return this.afs.collection<Estacao>(ESTACAO_CL, ref => ref
            .where(tipo, '>=', busca)
            // TODO: Verificar alternativa para o 'z', tentar usar o ultimo ASCII
            .where(tipo, '<=', busca + 'z')
        )
            .snapshotChanges()
            .pipe(
                map(actions =>
                    actions.map(a => {
                        const data = a.payload.doc.data();
                        const id = a.payload.doc.id;
                        return { id, ...data };
                    }))
            );
    }


    ordenar(ativo: string, direcao: any) {
        return this.afs.collection<Estacao>(ESTACAO_CL, ref => ref
            .orderBy(ativo, direcao)
        )
            .snapshotChanges()
            .pipe(
                map(actions =>
                    actions.map(a => {
                        const data = a.payload.doc.data();
                        const id = a.payload.doc.id;
                        return { id, ...data };
                    }))
            );
    }

    adicionar(estacao: Estacao): Promise<void> {
        console.log(estacao);
        return this.ref.add(JSON.parse(JSON.stringify(estacao))).then(() => { });
    }

    atualizar(id: string, estacao: Estacao): Promise<void> {
        //estacao.id = estacao.id;
        delete estacao.id;
        return this.ref.doc<Estacao>(id).set(estacao, { merge: true });
    }

    remover(id: string) {
        return this.ref.doc<Estacao>(id).delete();
    }
}
